export default "__VITE_ASSET__Blwa9$Mn__"